export default __webpack_public_path__ + "static/media/logo-smart-chatbotTiny.4289f778.png";